import React from 'react';

import classes from './CommonListItem.scss';

const commonListItem = (props) => (
    <li className={`${classes.Item} u-flex u-fontWeightRegular u-fontSize13`}><span className={classes.Bullet}></span>{props.children}</li>
);

export default commonListItem;


// WEBPACK FOOTER //
// ./src/components/Payment/Common/CommonList/CommonListItem/CommonListItem.js